import React, { memo } from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';

import { getBreadcrumbsFullURL } from '@/utils';

import { CurrentPage, Link, List, ListItem, Nav } from './styles';

const last = (list) => list[list?.length - 1];
const withoutLast = (list) => list.slice(0, -1);

function Breadcrumbs({ breadcrumbs = [] }) {
  const { name: currentPageName } = last(breadcrumbs);

  if (!breadcrumbs?.length) {
    return null;
  }

  return (
    <Nav>
      <Helmet
        script={[
          {
            type: 'application/ld+json',
            innerHTML: JSON.stringify({
              '@context': 'http://schema.org',
              '@type': 'BreadcrumbList',
              itemListElement: breadcrumbs.map(({ name, link }, index) => ({
                '@type': 'ListItem',
                position: index + 1,
                item: {
                  '@id': getBreadcrumbsFullURL(link, index),
                  name,
                },
              })),
            }),
          },
        ]}
      />

      <List>
        {withoutLast(breadcrumbs).map(({ link = '', name = '' }, index) => (
          <ListItem key={name || index}>
            <Link href={getBreadcrumbsFullURL(link, index)}>{name}</Link>
          </ListItem>
        ))}

        <ListItem>
          <CurrentPage aria-current="page">{currentPageName}</CurrentPage>
        </ListItem>
      </List>
    </Nav>
  );
}

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      name: PropTypes.string,
    }).isRequired
  ),
};

export default memo(Breadcrumbs);
